export default __webpack_public_path__ + "static/bCorp-70c9ca1886186d238a4e0cb1673fa73b.svg";